import type React from 'react';
import type { JSX } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomSportsBoxing = ({
    color,
    opacity = '1',
    fillOpacity = '0.9',
    size = 20,
    props,
}: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} {...props} viewBox="0 0 20 20">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.25 1C15.8733 1.00001 18 3.12665 18 5.75V10.0381C18 11.8232 17.1708 13.5073 15.7559 14.5957L14.75 15.3691V19H5.25V15.4189L3.30859 14.2246C2.49543 13.7242 2.00014 12.8376 2 11.8828V10.25C2 9.28899 2.49341 8.44383 3.24023 7.95215C3.08676 7.66909 3 7.34461 3 7V5C3 2.79086 4.79086 1 7 1H13.25ZM6.75 17.5H13.25V15.5H6.75V17.5ZM7 2.5C5.61929 2.5 4.5 3.61929 4.5 5V7C4.5 7.27614 4.72386 7.5 5 7.5H7.75C8.5301 7.5 9.21746 7.89701 9.62109 8.5H11.25C12.4926 8.5 13.5 7.49264 13.5 6.25V5H15V6.25C15 8.32107 13.3211 10 11.25 10H9.98535C9.86094 11.1249 8.9081 12 7.75 12H5V10.5H7.75C8.16421 10.5 8.5 10.1642 8.5 9.75C8.5 9.33579 8.16421 9 7.75 9H4.75C4.05965 9 3.5 9.55964 3.5 10.25V11.8828C3.50014 12.3167 3.72516 12.7198 4.09473 12.9473L5.80566 14H14.0693L14.8408 13.4062C15.8867 12.6018 16.5 11.3575 16.5 10.0381V5.75C16.5 3.95508 15.0449 2.50001 13.25 2.5H7Z"
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
